<template src="./Checkin.html">
</template>

<script>
import { checkPassengerInfo } from '@/services/passenger'
export default {
  data () {
    return {
      loading: false,
      model: {
        ref: ''
      }
    }
  },

  methods: {
    validateUserInfo () {
      this.loading = true
      checkPassengerInfo(this.model)
        .then(res => {
          this.loading = true
          this.$router.push({
            name: 'PrintPage',
            query: { ...this.model }
          })
        })
        .catch(() => {
          this.loading = false
          this.$notify.error({
            title: 'Manage Booking',
            message: 'Ticket Reference Not Valid'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.checkin {
  min-width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/checkin/Checkin.vue